import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { trpc } from "@/trpc";
import { useAuth } from "@/state/AuthContext";
import { PageLoading } from "@/components/layout/PageLoading";

export function MagicLinkPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user, isLoading, setUser } = useAuth();
  const token = searchParams.get("token") ?? "";
  const rawRedirect = searchParams.get("redirect") ?? "/";
  // Same-app paths only — an emailed link must not be able to bounce the
  // member to another site ("//host" is protocol-relative, so it's out too).
  const redirect = rawRedirect.startsWith("/") && !rawRedirect.startsWith("//") ? rawRedirect : "/";
  const hasDecidedRef = useRef(false);

  const { mutate } = trpc.auth.validateMagicLink.useMutation({
    onSuccess: (data) => {
      setUser(data.user);
      navigate(redirect, { replace: true });
    },
    onError: () => {
      navigate("/login", { replace: true });
    },
  });

  // Wait for the session check before deciding: someone already signed in
  // (say, clicking the second button in a post-event email) goes straight
  // through without consuming the token.
  useEffect(() => {
    if (isLoading || hasDecidedRef.current) return;
    hasDecidedRef.current = true;
    if (user) {
      navigate(redirect, { replace: true });
      return;
    }
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    mutate({ token });
  }, [isLoading, user, token, redirect, mutate, navigate]);

  return <PageLoading />;
}
